import React from 'react';
import dataModel from '../../models/DataModel';
import _ from 'lodash';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import BaseComponent from '../../baseClasses/BaseComponent';
import anime from 'animejs';
import MarketComboBox from '../../components/MarketComboBox';
import cancelIcon from '../../assets/images/close-icon.svg';
import DataSource from '../../dao/DataSource/DataSource';
import SelectUserComboBox from '../../components/SelectUserComboBox';
import TabbedPageControl from '../../components/TabbedPageControl';
import MultiFileUploader from '../../components/MultiFileUploader';
import FileUtil from '../..//helpers/FileUtil/FileUtil';
import PhotoCarousel from '../../components/PhotoCarousel';
import SelectTeamMembers from './SelectTeamMembers';
import SelectTeamProjects from './SelectTeamProjects';
import LoadingDots from '../LoadingDots';

import './TeamPopup.scss';
import Input from '../Input';
import { teamAssignedProjects } from '../../helpers/teamAssignedProjects';

const teamDescriptor = {
  team: {
    lead_user: {},
    users: {},
    markets: { company: {}, vendor_users: { role: {} }, users: { role: {} } },
  },
};

class TeamPopup extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      markets: null,
      selectedMarkets: null,
      team: { name: '', logo: null, markets: [], lead_user: null, users: [] },
      selectedTabName: 'team details',
      submitting: false,
    };

    this.closePopup = this.closePopup.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
    this.changeTeamName = this.changeTeamName.bind(this);
    this.showLogoPopup = this.showLogoPopup.bind(this);
    this.setTeamLogo = this.setTeamLogo.bind(this);
    this.deleteTeamLogo = this.deleteTeamLogo.bind(this);
    this.setMarketUsers = this.setMarketUsers.bind(this);
    this.queryCloseWithoutSave = this.queryCloseWithoutSave.bind(this);
    this.closeLogoPopup = this.closeLogoPopup.bind(this);
    this.marketsEqual = this.marketsEqual.bind(this);
    this.projectsEqual = this.projectsEqual.bind(this);
    this.commitNewTeamWizard = this.commitNewTeamWizard.bind(this);
    this.persistTeamMembersForEdit = this.persistTeamMembersForEdit.bind(this);
    this.persistTeamProjectsForEdit = this.persistTeamProjectsForEdit.bind(this);

    this.tabs = ['team details', 'team members', 'projects'];
    if (!props.teamId) {
      this.disabledTabs = ['team members', 'projects'];
    }

  }

  handleCompanyRetrieval(company) {
    // console.log(company)
    if (company) {
      this.setState({ company, markets: company.markets });
    }
  }

  handleTeamRetrieval(team, action, acData, fetchedData) {
    if (action == 'update') {
      return;
    }
    else if (fetchedData) {
      this.setState({ team: fetchedData, updatedTeamUsers: null });
    }
    else {
      const assigned = teamAssignedProjects(team);
      let selectedProjects = assigned.length ? assigned.map(project => { return project.id; }) : [];
      this.setState({ selectedProjects, team, originalMarkets: team.markets ? team.markets.map(m => { return m; }) : [] });
      if (!this.state.originalTeam) {
        this.setState({ originalTeam: _.cloneDeep(team) });
      }
      this.setMarketUsers(team.markets);
    }
  }

  marketsEqual(markets1, markets2) {
    if (!markets1 || !markets2) {
      return false;
    }
    if (markets1.length != markets2.length) {
      return false;
    }
    else {
      markets2.forEach(market2 => {
        if (!markets1.find(market1 => { return market1.id == market2.id; })) {
          return false;
        }
      });
      return true;
    }
  }

  projectsEqual(project1Ids, projects2) {
    if (!project1Ids || !projects2) {
      return false;
    }
    if (project1Ids.length != projects2.length) {
      return false;
    }
    else {
      projects2.forEach(project2 => {
        if (!project1Ids.find(project1Id => { return project1Id == project2.id; })) {
          return false;
        }
      });
      return true;
    }
  }

  handleAdvance(back) {
    const { team, active } = this.state;
    switch (this.state.selectedTabName) {
    case 'team details':
      if (back) {
      }
      else {
        this.setState({ selectedTabName: 'team members', active: this.state.updatedTeamUsers || (team.users && team.users.length > 0) });
      }
      break;
    case 'team members':
      if (back) {
        this.setState({ selectedTabName: 'team details', active: true });
      }
      else {
        this.disabledTabs = [];
        this.setState({ selectedTabName: 'projects', active: true });
      }
      break;
    case 'projects': 
      if (!this.props.teamId) {
        if (back) {
          this.setState({ selectedTabName: 'team members', active: true });
        }
        else {
          this.closePopup();
        }
      }
      else {
        this.setState({ active });
      }
      break;
    default:
      break;
    }
  }

  componentDidMount() {
    dataModel.setDisableAppBackground(true);
    this.popupCaption = 'CREATE TEAM';
    if (this.props.teamId) {
      this.popupCaption = 'EDIT TEAM';
      this.teamDataSource = new DataSource('Team', this.props.teamId, teamDescriptor, this.handleTeamRetrieval);
      this.teamDataSource.get();
      this.setState({ active: true });
    }
    const currentRole = this.props.currentUser ? this.props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.companyDataSource = new DataSource('Company', this.props.currentCompany.id, {
      company: {
        markets: {
          users: { additionalFields: ['profile_image'], role: {} },
          vendor_users: { additionalFields: ['profile_image'], role: {} },
        },
      },
    },
      this.handleCompanyRetrieval);
    this.companyDataSource.get();
  }

  componentWillUnmount() {
    if (this.companyDataSource) {
      this.companyDataSource.release();
      this.companyDataSource = null;
    }
    if (this.teamDataSource) {
      this.teamDataSource.release();
      this.teamDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
  }

  handleDeleteLogo() {
    let { team } = this.state;
    this.closeLogoPopup();
    if (this.teamDataSource) {
      this.teamDataSource.performAction('deleteTeamLogo', team, { recordDescriptor: teamDescriptor }).then(updatedTeam => {
        this.setState({ team: updatedTeam });
      });
    }
    else {
      delete team.logo;
      this.setState({ team: team });
    }
  }

  getMarketUsers(markets) {
    if (markets) {
      let users = [];
      markets.forEach(market => {
        if (market.users) {
          market.users.forEach(user => {
            if (!users.find(u => { return user.id == u.id; })) {
              if (!user.suspended && (user.role.name == 'admin' || user.role.name == 'editor')) {
                users.push(user);
              }
            }
          });
        }
  
        // if (market.vendor_users) {
        //   market.vendor_users.forEach(user => {
        //     if (!users.find(u => { return user.id == u.id })) {
        //       if (!user.suspended && (user.role.name == 'admin' || user.role.name == 'editor')) {
        //         users.push(user)
        //       }
        //     }
        //   })
        // }
      });
      return users;
    }
    return [];
  }

  setMarketUsers(markets) {
    const users = this.getMarketUsers(markets);
    this.setState({ users });
    return users;
  }

  showLogoPopup() {
    this.setState({ displayLogoPopup: true });
  }

  closeLogoPopup() {
    this.setState({ displayLogoPopup: false });
  }
  
  setTeamLogo(file, preview) {
    // this component depends on using a Data-URI for the logo,
    // thus preview is used instead of file (object)
    let team = this.state.team;
    team.logo = preview;
    let active = this.state.active;
    if (team.markets && team.markets.length > 0 && team.name) {
      active = true; 
    }
    this.setState({ team, active, logoChanged: true });
  }

  deleteTeamLogo() {
    let team = this.state.team;
    let active = this.state.active;
    if (team.markets && team.markets.length > 0 && (!this.marketsEqual(team.markets, this.state.originalMarkets) || this.props.teamId) && team.name) {
      active = true; 
    }
    this.setState({ displayLogoPopup: false, active, logoChanged: true }, () => this.setTeamLogo(null, null));
  }

  expandPopup() {
    return anime({
      targets: this.teamPopup,
      height: this.props.currentUser.super_admin ? 414 : 364,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  collapsePopup(e, force) {
    const { nameChanged, leadChanged, marketsChanged, logoChanged, teamMembersUpdated, projectsUpdated } = this.state;
    if (!force && (nameChanged || leadChanged || marketsChanged || logoChanged || teamMembersUpdated || projectsUpdated)) {
      this.queryCloseWithoutSave();
    }
    else {
      return anime({
        targets: this.teamPopup,
        height: 0,
        easing: 'easeInOutCubic',
        duration: 200,
        complete: () => {
          this.closePopup();
        },
      });
    }
  }
  
  queryCloseWithoutSave() {
    
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      cancelButtonText: this.textMap.cancel, 
      okButtonText: 'YES',
      width: 300, 
      height: 175, 
      message: 'Are you sure you want to exit? Your changes will not be saved.',
      handleOwnerOk: () => {
        this.collapsePopup(null, true);
      }, 
    });
  }

  closePopup() {
    dataModel.setDisableAppBackground(false);
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  collectNewWizardUserIds() {
    const src = this.state.updatedTeamUsers || this.state.team;
    if (!src.users || !src.users.length) {
      return [];
    }
    return src.users.filter(u => { return !u.toBeRemoved; }).map(u => { return u.id; });
  }

  commitNewTeamWizard() {
    if (this.state.submitting) {
      return;
    }
    const { team, selectAllProjects, selectedProjects, projectManagers, projectTypes } = this.state;
    this.setState({ submitting: true });
    const teamPayload = _.cloneDeep(team);
    let workingTeam;

    dataModel.teamsDAO.createTeam(teamPayload, null, { recordDescriptor: teamDescriptor })
      .then(created => {
        this.analyticsLogger.logTeamEvent('TeamCreated');
        workingTeam = created;
        const userIds = this.collectNewWizardUserIds();
        if (!userIds.length) {
          return workingTeam;
        }
        return dataModel.teamsDAO.bulkAddTeamUsers(workingTeam, userIds, { recordDescriptor: teamDescriptor });
      })
      .then(teamAfterUsers => {
        workingTeam = teamAfterUsers || workingTeam;
        if (selectAllProjects) {
          this.analyticsLogger.logTeamEvent('TeamAddedToProjectViaTeam');
          return dataModel.teamsDAO.bulkAddTeamProjects(workingTeam, {
            project_id: 'all',
            project_managers: projectManagers,
            project_types: projectTypes,
            markets: workingTeam.markets,
          }, { recordDescriptor: teamDescriptor });
        }
        if (selectedProjects && selectedProjects.length > 0) {
          this.analyticsLogger.logTeamEvent('TeamAddedToProjectViaTeam');
          return dataModel.teamsDAO.bulkAddTeamProjects(workingTeam, {
            project_ids: selectedProjects,
            markets: workingTeam.markets,
          }, { recordDescriptor: teamDescriptor });
        }
        return workingTeam;
      })
      .then(() => {
        this.setState({ submitting: false });
        this.closePopup();
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  }

  getTeamFromStoreForEdit() {
    const teamRecord = dataModel.teamsDAO.findItem(this.props.teamId);
    if (!teamRecord) {
      return this.state.team;
    }
    return dataModel.teamsDAO.mapToReturn(teamRecord, { recordDescriptor: teamDescriptor });
  }

  refreshEditTeamFromStore() {
    const teamId = this.props.teamId;
    if (!teamId) {
      return;
    }
    const fresh = dataModel.teamsDAO.findItem(teamId);
    if (!fresh) {
      return;
    }
    const mapped = dataModel.teamsDAO.mapToReturn(fresh, { recordDescriptor: teamDescriptor });
    const usersCopy = mapped.users ? mapped.users.map(u => { return { ...u }; }) : [];
    this.setState({
      team: mapped,
      updatedTeamUsers: usersCopy.length ? { ...mapped, users: usersCopy } : null,
      selectedProjects: teamAssignedProjects(mapped).map(p => { return p.id; }),
    });
  }

  persistTeamMembersForEdit() {
    if (!this.props.teamId || !this.teamDataSource || !this.state.updatedTeamUsers) {
      return Promise.resolve();
    }
    const team = this.getTeamFromStoreForEdit();
    const users = this.state.updatedTeamUsers.users;
    const toAdd = [];
    const toRemove = [];
    users.forEach(user => {
      if (user.toBeAdded) {
        toAdd.push(user.id);
      }
      if (user.toBeRemoved) {
        toRemove.push(user.id);
      }
    });
    if (!toAdd.length && !toRemove.length) {
      return Promise.resolve();
    }
    let chain = Promise.resolve();
    if (toAdd.length) {
      chain = chain.then(() => {
        return dataModel.teamsDAO.bulkAddTeamUsers(team, toAdd, { recordDescriptor: teamDescriptor });
      });
    }
    if (toRemove.length) {
      chain = chain.then(() => {
        return Promise.all(toRemove.map(userId => {
          return this.teamDataSource.performAction('removeTeamUser', team, userId, teamDescriptor);
        }));
      });
    }
    return chain.then(() => {
      this.refreshEditTeamFromStore();
    });
  }

  persistTeamProjectsForEdit() {
    if (!this.props.teamId || !this.teamDataSource) {
      return Promise.resolve();
    }
    const team = this.getTeamFromStoreForEdit();
    if (this.state.selectAllProjects) {
      this.analyticsLogger.logTeamEvent('TeamAddedToProjectViaTeam');
      return dataModel.teamsDAO.bulkAddTeamProjects(team, {
        project_id: 'all',
        project_managers: this.state.projectManagers,
        project_types: this.state.projectTypes,
        markets: team.markets,
      }, { recordDescriptor: teamDescriptor }).then(() => {
        this.refreshEditTeamFromStore();
      });
    }
    const toAdd = [];
    const toRemove = [];
    const assigned = teamAssignedProjects(team);
    if (assigned.length && this.state.selectedProjects) {
      assigned.forEach(project => {
        if (!this.state.selectedProjects.find(p => { return project.id == p; })) {
          toRemove.push(project.id);
        }
      });
    }
    if (this.state.selectedProjects) {
      this.state.selectedProjects.forEach(projectId => {
        if (!assigned.find(p => { return projectId == p.id; })) {
          toAdd.push(projectId);
        }
      });
    }
    if (!toAdd.length && !toRemove.length) {
      return Promise.resolve();
    }
    let chain = Promise.resolve();
    if (toAdd.length) {
      this.analyticsLogger.logTeamEvent('TeamAddedToProjectViaTeam');
      chain = chain.then(() => {
        return dataModel.teamsDAO.bulkAddTeamProjects(team, {
          project_ids: toAdd,
          markets: team.markets,
        }, { recordDescriptor: teamDescriptor });
      });
    }
    if (toRemove.length) {
      chain = chain.then(() => {
        return Promise.all(toRemove.map(projectId => {
          return this.teamDataSource.performAction('removeTeamProject', team, projectId, teamDescriptor);
        }));
      });
    }
    return chain.then(() => {
      this.refreshEditTeamFromStore();
    });
  }

  handleUpdateTeam(teamFromCaller) {
    // Use the edited team passed by the caller (it carries the in-progress
    // lead/name/markets/logo edits from state). Reading from the store here
    // would refetch the *original* values and drop the user's edits — that's
    // why changing the Team Lead never saved (AFB-191 regression). Fall back to
    // the store only when no caller team is provided.
    const team = teamFromCaller || this.getTeamFromStoreForEdit();
    const updateTeam = Object.assign({}, team);
    let somethingChanged = 4;
    if (!this.state.marketsChanged || this.marketsEqual(updateTeam.markets, this.state.originalMarkets)) {
      delete updateTeam.markets;
      somethingChanged--;
    }
    if (!this.state.leadChanged) {
      delete updateTeam.lead_user;
      somethingChanged--;
    }
    else if (!updateTeam.lead_user) {
      // Lead was deselected: this is a real change, so keep it counted in
      // somethingChanged and let the backend remove the lead.
      updateTeam.remove_lead_user = true;
    }
    if (!this.state.logoChanged) {
      delete updateTeam.logo;
      somethingChanged--;
    }
    if (!this.state.nameChanged) {
      somethingChanged--;
    }
    if (somethingChanged) {
      this.analyticsLogger.logTeamEvent('TeamEdited');
      return this.teamDataSource.update(updateTeam).then(() => {
        this.setState({ active: false, marketsChanged: false, nameChanged: false, logoChanged: false, leadChanged: false });
      });
    }
    this.setState({ active: false, marketsChanged: false, nameChanged: false, logoChanged: false, leadChanged: false });
    return Promise.resolve();
  }

  handleNext() {
    const { team, active, selectedTabName, submitting } = this.state;
    if (submitting) {
      return;
    }
    if (!this.props.teamId) {
      if (active) {
        if (selectedTabName === 'projects') {
          this.commitNewTeamWizard();
          return;
        }
        this.handleAdvance();
        return;
      }
      this.handleAdvance();
      return;
    }
    if (active) {
      let persist = Promise.resolve();
      if (selectedTabName == 'team members') {
        persist = this.persistTeamMembersForEdit();
      }
      else if (selectedTabName == 'projects') {
        persist = this.persistTeamProjectsForEdit();
      }
      else if (this.teamDataSource) {
        persist = this.handleUpdateTeam(team);
      }
      persist.then(() => {
        this.closePopup();
      }).catch(() => {});
      return;
    }
    this.closePopup();
  }

  // Whether an edit-mode save can be committed. Unlike `active` (used by the
  // create wizard), this does NOT require a lead — removing the lead is a valid
  // edit. It requires a dirty change plus minimal validity (name + markets).
  canSaveEdit() {
    const { team, nameChanged, leadChanged, marketsChanged, logoChanged, projectsUpdated, teamMembersUpdated } = this.state;
    const dirty = nameChanged || leadChanged || marketsChanged || logoChanged || projectsUpdated || teamMembersUpdated;
    const valid = !!(team.name && team.name.trim() !== '' && team.markets && team.markets.length > 0);
    return dirty && valid;
  }

  handleSave() {
    const { team, submitting } = this.state;
    if (submitting || !this.canSaveEdit()) {
      return;
    }
    this.setState({ submitting: true });
    this.persistTeamMembersForEdit()
      .then(() => this.persistTeamProjectsForEdit())
      .then(() => this.handleUpdateTeam(team))
      .then(() => {
        this.setState({ submitting: false });
        this.closePopup();
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  }

  handlePrev() {
    const { team, active, selectedTabName, submitting } = this.state;
    if (submitting) {
      return;
    }
    if (!this.props.teamId) {
      this.handleAdvance(true);
      return;
    }
    if (active) {
      let persist = Promise.resolve();
      if (selectedTabName == 'team members') {
        persist = this.persistTeamMembersForEdit();
      }
      else if (selectedTabName == 'projects') {
        persist = this.persistTeamProjectsForEdit();
      }
      else if (this.teamDataSource) {
        persist = this.handleUpdateTeam(team);
      }
      persist.then(() => {
        this.handleAdvance(true);
      }).catch(() => {});
      return;
    }
    this.handleAdvance(true);
  }

  handleMarketChange(markets) {
    let team = this.state.team;
    team.markets = markets.map(market => {
      return market.market;
    });
    let active = this.state.active;
    const marketsChanged = !this.marketsEqual(team.markets, this.state.originalMarkets); 
    if (team.markets && team.markets.length > 0 && team.name && team.lead_user) {
      active = true; 
    }
    else{
      active = false;
      this.disabledTabs = ['team members', 'projects'];
    }
    
    // Get users from selected markets and update state in one call
    const users = this.getMarketUsers(team.markets);
    this.setState({ team, active, marketsChanged, resetProjects: true, users });
    
    if (marketsChanged && teamAssignedProjects(team).length) {
      this.setState({ selectedProjects: [] });
    }
    else {
      const assigned = teamAssignedProjects(team);
      if (assigned.length) {
        this.setState({ selectedProjects: assigned.map(project => { return project.id; }) });
      }
    }
    if (users && team.lead_user && !users.find(user => { return user.id == team.lead_user.id; })) {
      team.lead_user = null;
    }
  }

  handleLeadSelection(option, lead) {
    let team = this.state.team;
    let active = this.state.active;
    if (lead.selected) {
      team.lead_user = lead.user;
    }
    else {
      team.lead_user = null;
    }
    if (team.markets && team.markets.length > 0 && team.name && team.lead_user) {
      active = true;
    }
    else{
      active = false;
      this.disabledTabs = ['team members', 'projects'];
    }
    this.setState({ team, active, leadChanged: true });
  }

  changeTeamName(e) {
    let team = this.state.team; 
    if(e.target.value.trim() !== '' || !e.target.value){
      team.name = e.target.value;
      let active = this.state.active;
      if (team.markets && team.markets.length > 0 && team.name && team.lead_user) {
        active = true; 
      }
      else{
        active = false;
        this.disabledTabs = ['team members', 'projects'];
      }
      this.setState({ team, active, nameChanged: true });
    }
  }

  handleTabClick(tabName) {
    let active = this.state.active;
    if (!active) {
      return;
    }
    const { team, selectedTabName, submitting } = this.state;
    if (submitting) {
      return;
    }
    if (!this.props.teamId) {
      this.setState({ selectedTabName: tabName, active });
      return;
    }
    let persist = Promise.resolve();
    if (selectedTabName == 'team members') {
      persist = this.persistTeamMembersForEdit();
    }
    else if (selectedTabName == 'projects') {
      persist = this.persistTeamProjectsForEdit();
    }
    else if (this.teamDataSource) {
      persist = this.handleUpdateTeam(team);
    }
    persist.then(() => {
      this.setState({ selectedTabName: tabName, active });
    }).catch(() => {});
  }

  handleManageTeamUsers(updatedTeamUsers) {
    if (updatedTeamUsers.users.length > 0) {
      this.disabledTabs = [];
    }
    else {
      this.disabledTabs = ['projects'];
    }
    let active = this.state.active;
    let teamMembersUpdated;
    
    teamMembersUpdated = (updatedTeamUsers.users.filter(user => { return user.toBeAdded || user.toBeRemoved; }).length != 0);
    active = active || teamMembersUpdated;
    if (!this.props.teamId) {
      active = false;
      if (updatedTeamUsers.users) {
        updatedTeamUsers.users.forEach(user => {
          if (user.toBeAdded) {
            active = true;
          }
        });
      }
    }
    this.setState({ updatedTeamUsers, active, teamMembersUpdated });
  }

  handleManageTeamProjects(selectedProjects, selectAllProjects, projectManagers, projectTypes) {
    let active = this.state.active;
    let projectsUpdated;
    if (!this.props.teamId) {
      active = true;
    }
    else {
      projectsUpdated = !this.projectsEqual(selectedProjects, teamAssignedProjects(this.state.originalTeam));
      active = active || projectsUpdated;
    }
    this.setState({ selectedProjects, active, selectAllProjects, projectManagers, projectTypes, resetProjects: false, projectsUpdated });
  }

  handleCreateTeamDetails(visible) {
    return <div className={'team-container'} style={{ display: visible ? 'flex' : 'none' }}>
      <div className='team-info'>
        <p className='caption required'>TEAM NAME</p>
        <Input
          className='team-name-input'
          name='teamName'
          value={this.state.team.name}
          placeholder={'Enter a Team Name'}
          onChange={this.changeTeamName}
        />
        <p className='caption required'>MARKETS</p>
        <div className="team-combo-box">
          <MarketComboBox
            markets={this.state.markets}
            height={32}
            width={254}
            backgroundIndex={27}
            hasBorder={false}
            multiSelect={true}
            defaultText={this.textMap.markets}
            displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#000000', textIndent: '0px', marginTop: '0px' }}
            handleSelectMarket={this.handleMarketChange}
            currentOption={this.state.team.markets}
          />
        </div>
  
        <p className='caption required'>TEAM LEAD</p>
        <div className="team-combo-box">
          <SelectUserComboBox
            id={'team-user'}
            key="team-user"
            width={254}
            backgroundIndex={27}
            hasBorder={false}
            multiSelect={false}
            height={24}
            menuBelow={true}
            small={true}
            displayFontStyle={{ fontSize: '13px' }}
            handleSelection={this.handleLeadSelection}
            currentSelectedUser={this.state.team.lead_user}
            users={this.state.users}
            dontFocus={true}
          />
        </div>

      </div>
      <div className="team-logo-container">
        <div className="caption">{'TEAM LOGO'}</div>
        {
          this.state.team.logo ?
            <img className="team-logo" src={this.state.team.logo} onClick={this.showLogoPopup} alt='team logo' /> :
            <MultiFileUploader
              shouldGenerateImagePreview={true}
              handleFileSelect={this.setTeamLogo}
              maximumNumberOfFiles={1}
              acceptedFileTypes={FileUtil.extensionTypes.photoTypes.split(',')}
            />
        }
      </div>
    </div>;
  }

  teamForWizardChild(baseTeam) {
    const t = baseTeam || this.state.team;
    return { ...t, id: t.id != null ? t.id : 'new', users: t.users || [] };
  }

  handleCreateTeamUsers(visible) {
    const memberTeam = this.teamForWizardChild(this.state.updatedTeamUsers || this.state.team);
    return <SelectTeamMembers key='select-team-members' visible={visible}
      team={memberTeam}
      multiSelect={true}
      users={this.state.users}
      type="add"
      updateTeam={this.props.updateTeam}
      handleManageTeamUsers={this.handleManageTeamUsers}
    />;
  }

  handleCreateTeamProjects(visible) {
    return <SelectTeamProjects key="select-team-projects" visible={visible} resetProjects={this.state.resetProjects} marketsChanged={this.state.marketsChanged}
      team={this.teamForWizardChild(this.state.team)}
      handleManageTeamProjects={this.handleManageTeamProjects}
      handleResetProjects={() => { this.setState({ resetProjects: false });}}
    />;
  }

  render() {
    const { isSaveButtonEnable, submitting } = this.state;
    const logoAttachment = {
      upload: this.state.team.logo,
    };

    let teamDetails = null;
    let teamUsers = null;
    let teamProjects = null;
    if (this.state.selectedTabName == 'team details') {
      teamDetails = this.handleCreateTeamDetails(true);
    }
    else {
      teamDetails = this.handleCreateTeamDetails(false);
    }
    if (this.state.selectedTabName == 'team members') {
      teamUsers = this.handleCreateTeamUsers(true);
    }
    else {
      teamUsers = this.handleCreateTeamUsers(false);
    }
    if (this.state.selectedTabName == 'projects') {
      teamProjects = this.handleCreateTeamProjects(true);
    }
    else {
      teamProjects = this.handleCreateTeamProjects(false);
    }
    let nextCaption = !this.props.teamId ? 'NEXT' : 'SAVE';
    if (this.state.selectedTabName == 'projects' && !this.props.teamId) {
      nextCaption = 'DONE';
    }

    let nextButtonClass = 'next-button';
    if(this.state.active){
      nextButtonClass = 'next-button active';
    }
    if(this.props.teamId){
      const canSave = this.canSaveEdit();
      if(canSave){
        nextButtonClass = 'next-button active';
        if(!isSaveButtonEnable){
          this.setState({ isSaveButtonEnable: true });
        }
      }
      else{
        nextButtonClass = 'next-button';
        if(isSaveButtonEnable){
          this.setState({ isSaveButtonEnable: false });
        }
      }
    }
    return (
      <article
        className='team-popout'
        ref={el => this.teamPopup = el}
      >
        {
          this.state.displayLogoPopup &&
          <div className="company-crud__logo-popup">
            <PhotoCarousel
              attachments={[logoAttachment]}
              hasRename={false}
              hasDelete={true}
              parentDelete={true}
              handleDelete={this.handleDeleteLogo}
              handleClose={this.closeLogoPopup}
            />
          </div>
        }

        <header className='team-popout__header'>
          <div className='caption'>
            {this.popupCaption}
            </div>
          <div className='close-button'>
            <img
              src={cancelIcon}
              alt="cancel"
              className='close-button'
              onClick={this.collapsePopup}
            />
          </div>
        </header>
        <TabbedPageControl
          tabItems={this.tabs}
          disabledItems={this.disabledTabs}
          selectedTabName={this.state.selectedTabName}
          handleClick={this.handleTabClick}
        />
        <section className='team-popout__container'>
          {teamDetails}
          {teamUsers}
          {teamProjects}
        </section>
        <div className='team-popout__button-container'>
          {!this.props.teamId && this.state.selectedTabName != 'team details' ?
          <button
          className={'prev-button'}
          onClick={this.handlePrev}
        >
          {'PREV'}
        </button> : null
        }
          {this.props.teamId ?
          <button
          className={'cancel-button'}
          onClick={this.collapsePopup}
        >
          CANCEL
        </button> : null
        }
          <button
            className={nextButtonClass}
            onClick={submitting ? null : (!this.props.teamId ? (this.state.active ? this.handleNext : null) : (this.canSaveEdit() ? this.handleSave : null))}
          >
            {submitting ? <LoadingDots smaller color={'#ffffff'} /> : nextCaption}
          </button>
        </div>
      </article>
    );
  }

}

export default TeamPopup;



// WEBPACK FOOTER //
// ./src/components/TeamPopup/index.js